import firebase from '../firebase'
import FirebaseHelpers from '../helpers/FirebaseHelpers'

var db = firebase.database()

export default class {

static fetchItemSingle (ref) {
    return new Promise((resolve, reject) => {
        ref.once('value', (snap) => {
            let obj = {key: snap.key}
            for(let fld in snap.val()) {
                if(!fld.startsWith('_')) {
                    obj[fld] = snap.val()[fld]
                }
            }
            resolve(obj)
        })
    })       
}

static snapToObj(snap) {
    let obj = {key: snap.key}
    for(let fld in snap.val()) {
        if(!fld.startsWith('_')) {
            obj[fld] = snap.val()[fld]
        }
    } 
    return obj   
}

static fetchItems (ref) {
    return new Promise((resolve, reject) => {
        ref.once('value', (snap) => {
            let returnArr = []
            snap.forEach(childSnapshot => {
                let item = childSnapshot.val(); 
                item.key = childSnapshot.key
                returnArr.push(item)
            })
            resolve(returnArr)
        })
    })       
}

static fetchItemsToStore (ref) {
    this.fetchItems(ref).then(items => {
        
    })
}

//no ['.key'] version
static snapshotToArray  (snapshot) {
    let returnArr = []

    snapshot.forEach(childSnapshot => {
        let item = childSnapshot.val(); 
        item.key = childSnapshot.key
        returnArr.push(item)
    })

    return returnArr
}

static saveItem(item, ref) {
    FirebaseHelpers.saveToFirebase(item, ref)
}



} // end class


// WEBPACK FOOTER //
// ./src/data/FireData.js